module.exports = __webpack_public_path__ + "img/fig1.770ab1cb.png";